import {
  convertToMSPTimeZone,
  DateTimeFormatter,
  getTranslatedText
} from '@nile/components';
import { Card, TextStyle, Tippy } from '@superops/ui-design-system';
import { getTimeAgo } from '@nile/components/src/Components/Notifications/time';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import AttributesHandler from './AttributeHandler';

function ChatAuditLog({
  audit,
  intl,
  icon,
  actorDetails,
  getMessageKeyValues,
  getKey,
  AttributesMap
}) {
  const { parentEntity, entity, operation, data, time } = audit;

  const filteredAttributes = data?.[0]?.attributes?.filter(
    (el) => el?.name !== 'status'
  );

  return (
    <Card>
      <div className="p10 br-5">
        <div className="fx actr g5 wrap">
          <span className="fx actr mr-5">{icon}</span>
          <FormattedMessage
            id={getMessageKeyValues(entity, parentEntity, data, operation)}
            values={{
              AuditlogOperation: (
                <TextStyle variation="strong" weight="Bold" uppercase>
                  {getTranslatedText(intl, getKey(audit))}
                </TextStyle>
              ),
              strong: (chunks) => <strong>{chunks}</strong>
            }}
          />
          {actorDetails}
        </div>
        <span className="ml-26 d-in">
          <TextStyle variation="subdued">
            <Tippy
              content={
                <div className="p0510">
                  <DateTimeFormatter type="dateTime" date={time} />
                </div>
              }
              duration={250}
              delay={250}
              interactive
              placement="bottom-start"
              arrow={false}
              allowHTML
              theme="dark"
              appendTo={document.body}
            >
              <div>
                {getTimeAgo(time.toString(), convertToMSPTimeZone(new Date()))}
              </div>
            </Tippy>
          </TextStyle>
        </span>
        {!isEmpty(filteredAttributes) && (
          <div className="fx col g10 lightpurple-to-black-bg mt5 px-25 br-5 py-10">
            {filteredAttributes?.map((attr) => {
              return (
                <AttributesHandler
                  skipName={false}
                  showInitial={false}
                  attributes={filteredAttributes}
                  entityAttributesMap={AttributesMap}
                  entityName={entity}
                />
              );
            })}
          </div>
        )}
      </div>
    </Card>
  );
}

export default ChatAuditLog;
